module.exports = __webpack_public_path__ + "static/media/fashion_men-300.e9c962a8.png";